// +----------------------------------------------------------------------
// | Desc:格式化库(原数据处理与存储)
// +----------------------------------------------------------------------
// | Time:2021年10月25日 22:44
// +----------------------------------------------------------------------
import Vue from "vue";
import _, { isArray } from "lodash";

// +----------------------------------------------------------------------
// | Desc:提取字符并用逗号连接
// +----------------------------------------------------------------------
Vue.prototype.$arrTocomma = function (items, key = "id") {
  if (_.isArray(items)) {
    // 处理一维数组或对象数组
    const values = items.map((item) => {
      // 如果 item 是对象，则使用 key 提取值；如果是简单值，则直接返回
      return typeof item === "object" && item !== null ? item[key] : item;
    });
    return _.join(values, ",");
  } else {
    // 如果 items 不是数组，则返回空字符串
    return "";
  }
};

// +----------------------------------------------------------------------
// | Desc:字符串由符号分隔拆分为数组
// +----------------------------------------------------------------------
Vue.prototype.$commaToarr = function (str, key = ",") {
  if (this.$isblank(str)) {
    return [];
  }
  return _.split(str, key);
};

// +----------------------------------------------------------------------
// | Desc:解析JSON字符串
// +----------------------------------------------------------------------
Vue.prototype.$jsonParse = function (jsonString) {
  if (this.$isblank(jsonString)) {
    return "";
  }
  try {
    var jsonObject = JSON.parse(jsonString);
    return jsonObject;
  } catch (error) {
    console.error("解析JSON字符串时发生错误：", error);
    return "";
  }
};

// +----------------------------------------------------------------------
// | Desc:数字友好显示
// +----------------------------------------------------------------------
Vue.prototype.$amount = function (amount) {
  if (amount == "0") {
    return "0.00￥";
  }
  if (this.$isblank(amount)) {
    return "请先完善定单信息";
  }
  const formattedAmount = parseFloat(amount).toFixed(2);
  return formattedAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "￥";
};

// +----------------------------------------------------------------------
// | Desc:ID加密
// +----------------------------------------------------------------------
Vue.prototype.$decryptToId = function (encryptedId, key = "874547") {
  let encryptedHigh = Math.floor(encryptedId / 1000);
  let encryptedLow = encryptedId % 1000;
  let keyHigh = Math.floor(key / 1000);
  let keyLow = key % 1000;
  let idHigh = encryptedHigh ^ keyHigh;
  let idLow = encryptedLow ^ keyLow;
  let id = idHigh * 1000 + idLow;
  return id;
};

// +----------------------------------------------------------------------
// | Desc:ID解密
// +----------------------------------------------------------------------
Vue.prototype.$encryptToId = function (encryptedId, key = "874547") {
  if (encryptedId < 100000 || encryptedId >= 1000000 || key < 100000 || key > 999999) {
  }
  let encryptedHigh = Math.floor(encryptedId / 1000);
  let encryptedLow = encryptedId % 1000;
  let keyHigh = Math.floor(key / 1000);
  let keyLow = key % 1000;
  let idHigh = encryptedHigh ^ keyHigh;
  let idLow = encryptedLow ^ keyLow;
  let id = idHigh * 1000 + idLow;
  return id;
};

// +----------------------------------------------------------------------
// | Desc:自动过滤掉所有的空格
// +----------------------------------------------------------------------
Vue.prototype.$trimObjectSpaces = function (obj) {
  var _this = this;
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === "string") {
        obj[key] = _this.$trimAll(obj[key]); // 去除字符串首尾空格
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        // 如果属性值是对象，则递归调用自身
        _this.$trimObjectSpaces(obj[key]);
      }
    }
  }
  return obj;
};

// +----------------------------------------------------------------------
// | Desc:去所有空格
// +----------------------------------------------------------------------
Vue.prototype.$trimAll = function (value) {
  return value.replace(/\s+/g, "");
};

// +----------------------------------------------------------------------
// | Desc:去尾法
// +----------------------------------------------------------------------
Vue.prototype.$toFloor = function (num) {
  return Math.floor(num);
};

// +----------------------------------------------------------------------
// | Desc:进一法
// +----------------------------------------------------------------------
Vue.prototype.$toCeil = function (num) {
  return Math.ceil(num);
};

// +----------------------------------------------------------------------
// | Desc:四舍五入法
// +----------------------------------------------------------------------
Vue.prototype.$toRound = function (num) {
  return Math.round(num);
};

// +----------------------------------------------------------------------
// | Desc:去除字符串中的指定字符
// +----------------------------------------------------------------------
Vue.prototype.$filterString = function (input, charToRemove) {
  if (typeof input !== "string" || typeof charToRemove !== "string") {
    return input;
  }
  return input.split(charToRemove).join("");
};

// +----------------------------------------------------------------------
// | Desc:格式化富文本编辑器中的内容
// +----------------------------------------------------------------------
Vue.prototype.$richtextFmt = function (content) {
  if (this.$isblank(content)) {
    return "";
  }
  let reg = /(style|class)="[^"]+"/gi;
  let img = /<img[^>]+>/gi;
  let res;
  if (img.test(content)) {
    res = content.match(img);
    for (let i = 0; i < res.length; i++) {
      content = content.replace(res[i], res[i].replace(reg, ""));
    }
  }
  content = content
    .replace(/\<img/gi, '<img class="richImg"  ')
    .replace(/<p([\s\w"=\/\.:;]+)((?:(style="[^"]+")))/gi, "<p")
    .replace(/<p([\s\w"=\/\.:;]+)((?:(class="[^"]+")))/gi, "<p")
    .replace(/<p>/gi, '<p class="richP">')
    .replace(/src="/g, 'src="' + this.$config.img);
  return content;
};

// +----------------------------------------------------------------------
// | Desc:唯一标识，随机数
// +----------------------------------------------------------------------
Vue.prototype.$unique = function () {
  // 生成时间戳
  const timestamp = Date.now().toString(36);
  // 生成随机数
  const randomStr = Math.random().toString(36).substr(2, 5);
  // 合并时间戳和随机数
  const uniqueId = timestamp + randomStr;
  uni.setStorageSync("uniqueid", uniqueId);
  return uniqueId;
};

// +----------------------------------------------------------------------
// | Desc:缓存存取
// +----------------------------------------------------------------------
Vue.prototype.$setLocalStorage = function (key, value) {
  localStorage.setItem(key, JSON.stringify(value));
};

Vue.prototype.$getLocalStorage = function (key) {
  if (this.$isblank(key)) {
    return "";
  }
  let global = localStorage.getItem(key);
  return JSON.parse(global);
};

// +----------------------------------------------------------------------
// | Desc:处理数据表格columns配置项过滤hide为ture的列
// +----------------------------------------------------------------------
Vue.prototype.$colFilter = function (dataList) {
  return dataList.filter((item) => !item.hide);
};

// +----------------------------------------------------------------------
// | Desc:处理数据表格中表单数据获取（如排序时）
// +----------------------------------------------------------------------
Vue.prototype.$getTableChangeFrom = function (value) {
  var that = this;
  if (this.$isblank(that.editId)) {
    return;
  }
  var list = this.editList || [];
  var item = {};
  item["id"] = that.editId;
  item["value"] = value;
  const existingIndex = this.$FMT.findIndex(list, {
    id: that.editId,
  });
  if (existingIndex !== -1) {
    list[existingIndex] = item;
  } else {
    list.push(item);
  }
  that.editList = list;
  return list;
};

// +----------------------------------------------------------------------
// | Desc: 递归更新目标对象中的字段，只替换目标对象中存在的字段，一般用于表单数据回显
// +----------------------------------------------------------------------
// | Param: target - 目标对象，需要被更新的对象
// | Param: source - 源对象，包含新的字段值
// +----------------------------------------------------------------------
Vue.prototype.$deepUpdateField = function (target, source) {
  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      if (target.hasOwnProperty(key)) {
        if (typeof target[key] === "object" && target[key] !== null && typeof source[key] === "object" && source[key] !== null) {
          // 如果字段是对象，递归更新
          this.$deepUpdateField(target[key], source[key]);
        } else {
          // 否则直接替换
          target[key] = source[key];
        }
      }
    }
  }
  //如果存在password字段针对性验证
  if (source.hasOwnProperty("password")) {
    target.password = "";
  }
  return target; // 返回更新后的目标对象
};

// +----------------------------------------------------------------------
// | Desc: 递归更新目标对象中的字段，只替换目标对象中存在的字段，一般用于表单数据回显
// +----------------------------------------------------------------------
Vue.prototype.$isSubmitValidGetPram = function (that, data) {
  that.form = that.$trimObjectSpaces(that.form);
  if (!that.$validAll(that.form, data.rule)) {
    return false;
  }
  const parameter = {
    ...that.form,
  };
  //如果存在password字段针对性验证
  if (parameter.hasOwnProperty("password")) {
    if (that.$isblank(that.form.id)) {
      if (!that.$isAccount(parameter.password)) {
        that.$msg("登录密码只能是6-16位的字母或数字，且必须含字母", "warning");
        return false;
      }
    }
    console.log(parameter);
    if (!that.$isblank(parameter.password) && parameter.password !== parameter.repassword) {
      that.$msg("登录密码和确认密码不一致", "warning");
      return false;
    }
    if (!this.$isblank(parameter.password)) {
      parameter.password = that.$MD5(parameter.password);
    }
    if (parameter.hasOwnProperty("oldpassword")) {
      parameter.oldpassword = that.$MD5(parameter.oldpassword);
    }
    //清理parameter.repassword
    delete parameter.repassword;
  }
  return parameter;
};

// +----------------------------------------------------------------------
// | Desc:将逗号分隔的字符串转换为数组
// +----------------------------------------------------------------------
Vue.prototype.$commaStringToArray = function (string) {
  if (this.$isblank(string)) {
    return [];
  }
  string = string + "";
  let array = string.split(",");
  array = array.map((item) => item.trim());
  array = array.filter((item) => item !== "");
  array = array.map((item) => {
    if (typeof item === "string") {
      const num = parseInt(item, 10);
      if (!isNaN(num) && num.toString() === item) {
        return num;
      }
    }
    return item;
  });
  return array;
};

// +----------------------------------------------------------------------
// | Desc:将数组转换为逗号分隔的字符串
// +----------------------------------------------------------------------
Vue.prototype.$arrayToCommaString = function (array) {
  if (this.$isblank(array)) {
    return "";
  }
  if (!array) {
    return "";
  }
  array = array.map((item) => String(item));
  let string = array.join(",");
  return string;
};

// +----------------------------------------------------------------------
// | Desc:str字符串是否在value1,2,3,4
// +----------------------------------------------------------------------
Vue.prototype.$isArr = function (str, value) {
  if (this.$isblank(str) || this.$isblank(value)) {
    return false;
  }
  var strArray = this.$commaStringToArray(str);
  var valueArray = this.$commaStringToArray(value);

  // 检查 strArray 中的每个元素是否在 valueArray 中
  for (var i = 0; i < strArray.length; i++) {
    if (!valueArray.includes(strArray[i])) {
      return false;
    }
  }
  return true;
};

// +----------------------------------------------------------------------
// | Desc:str字符串是否在value1,2,3,4
// +----------------------------------------------------------------------
Vue.prototype.$isArrOr = function (str, value) {
  if (this.$isblank(str) || this.$isblank(value)) {
    return false;
  }
  var strArray = this.$commaStringToArray(str);
  var valueArray = this.$commaStringToArray(value);

  // 检查是否有交集
  var res = strArray.some((item) => valueArray.includes(item));
  if (this.$isblank(res)) {
    return false;
  }
  return res;
};

// +----------------------------------------------------------------------
// | Desc:数据库字段中取第一张图片
// +----------------------------------------------------------------------
Vue.prototype.$getFritImg = function (value) {
  if (this.$isblank(value)) {
    return "";
  }
  if (!isArray(value)) {
    var value = this.$jsonParse(value);
  }
  return value[0]["url"];
};

// +----------------------------------------------------------------------
// | Desc:深拷贝数组
// +----------------------------------------------------------------------
Vue.prototype.$copyObj = function (data) {
  return JSON.parse(JSON.stringify(data));
};

// +----------------------------------------------------------------------
// | Desc:字段更新,$B字段值更新到对应的$A
// +----------------------------------------------------------------------
Vue.prototype.$fieldUpdate = function (A, B) {
  for (const key in B) {
    if (A.hasOwnProperty(key)) {
      A[key] = typeof B[key] === 'number' 
        ? Math.round(B[key])
        : B[key];
    }
  }
  return A;
};

// +----------------------------------------------------------------------
// | Desc: 复制文字
// +----------------------------------------------------------------------
Vue.prototype.$copy = function (text) {
  let _this = this;
  if (!navigator.clipboard) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    const successful = document.execCommand("copy");
    document.body.removeChild(textArea);

    if (successful) {
      _this.$msg(`${text} 已复制到剪贴板`, "success");
    } else {
      _this.$msg("复制失败", "error");
    }
  } else {
    // Modern browsers
    navigator.clipboard
      .writeText(text)
      .then(() => {
        _this.$msg(`${text} 已复制到剪贴板`, "success");
      })
      .catch((err) => {
        _this.$msg("复制失败:", "error");
      });
  }
};


// +----------------------------------------------------------------------
// | Desc: 保留小数,不是整数保留两位小数,是字符串类数字转成数字再处理,其他的返回实际的
// +----------------------------------------------------------------------
Vue.prototype.$xiaoshu = function (text) {
  // 处理数字和数字字符串
  const processNumber = (num) => {
    return Number.isInteger(num) 
      ? num.toString()      // 整数返回字符串形式
      : num.toFixed(2);     // 非整数保留两位小数
  };

  // 处理字符串类型
  if (typeof text === 'string') {
    const numberValue = Number(text);
    return isNaN(numberValue) ? text : processNumber(numberValue);
  }
  
  // 处理数字类型
  if (typeof text === 'number') {
    return processNumber(text);
  }

  // 其他类型直接返回
  return text;
};




// +----------------------------------------------------------------------
// | Desc:在Vue原型上挂载加密方法
// +----------------------------------------------------------------------
Vue.prototype.$encrypt = function (data, key = "wwdjhdhGDGvdb33Gfgdd", expire = 0) {
  // 如果 key 为空，可以在这里设置默认密钥
  if (!key) {
    key = "your_default_key_here"; // 替换为你的密钥
  }

  // 将数据进行 Base64 编码
  data = btoa(data);

  // 生成与数据长度相同的密钥字符序列
  let x = 0;
  let l = key.length;
  let char = "";
  for (let i = 0; i < data.length; i++) {
    if (x === l) x = 0;
    char += key.charAt(x);
    x++;
  }

  // 添加过期时间
  let str = expire > 0 ? ("" + (expire + Math.floor(Date.now() / 1000))).padStart(10, "0") : "0000000000";

  // 对数据进行加密
  for (let i = 0; i < data.length; i++) {
    str += String.fromCharCode(data.charCodeAt(i) + (char.charCodeAt(i) % 256));
  }

  // 将结果进行 Base64 编码，并替换特殊字符为 URL 安全字符
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

// +----------------------------------------------------------------------
// | Desc:在Vue原型上挂载解密方法
// +----------------------------------------------------------------------
Vue.prototype.$decrypt = function (value, key = "wwdjhdhGDGvdb33Gfgdd") {
  // 如果 key 为空，可以在这里设置默认密钥
  if (!key) {
    key = "your_default_key_here"; // 替换为你的密钥
  }

  if (!data) return "";

  // 替换 URL 安全字符为标准 Base64 字符
  data = data.replace(/-/g, "+").replace(/_/g, "/");
  // 补充 Base64 编码的填充字符
  while (data.length % 4 !== 0) {
    data += "=";
  }

  // 解码 Base64
  data = atob(data);

  // 提取过期时间
  let expire = parseInt(data.substring(0, 10));
  data = data.substring(10);

  // 检查过期时间
  if (expire > 0 && expire < Math.floor(Date.now() / 1000)) {
    return "";
  }

  // 生成与数据长度相同的密钥字符序列
  let x = 0;
  let l = key.length;
  let char = "";
  for (let i = 0; i < data.length; i++) {
    if (x === l) x = 0;
    char += key.charAt(x);
    x++;
  }

  // 对数据进行解密
  let str = "";
  for (let i = 0; i < data.length; i++) {
    let encryptedChar = data.charCodeAt(i);
    let keyChar = char.charCodeAt(i);
    let decryptedChar;

    if (encryptedChar < keyChar) {
      decryptedChar = encryptedChar + 256 - keyChar;
    } else {
      decryptedChar = encryptedChar - keyChar;
    }

    str += String.fromCharCode(decryptedChar);
  }

  // 解码 Base64 并返回结果
  return atob(str);
};